import React from 'react'
import { PieChart } from '@mui/x-charts/PieChart'

const PieChartCard = ({ data }) => {
  return (
    <PieChart
      series={[
        {
          data: data?.map((item, i) => ({
            id: i,
            value: item.value,
            label: item.label + item.value,
          })),
        },
      ]}
      width={200}
      height={200}
    />
  )
}

export default PieChartCard
